"use client";

import React, { useEffect } from "react";
import { useSearchParams } from "next/navigation";
import type { ButtonProps } from "app/_components/components/Button";
import { Button } from "app/_components/components/Button";
import Link from "next/link";
import { mixpanelClient } from "analytics/mixpanel";
import storage from "config/storage";
import queryString from "query-string";

export function BaseLink({
  href,
  id,
  label,
  referralCode,
  ...props
}: {
  href: string;
  id: string;
  label: string;
  referralCode?: string;
} & ButtonProps) {
  const searchParams = useSearchParams();

  const clickId =
    storage.get("affiliateClickId", "sessionStorage") ||
    searchParams?.get("~click_id");

  useEffect(() => {
    mixpanelClient.trackLinkClick(id, true);
  }, [clickId, id]);

  const finalReferralCode = referralCode
    ? referralCode
    : searchParams?.get("referralCode");

  const queryParams = clickId
    ? queryString.stringify({
        referral: finalReferralCode,
        ["~click_id"]: clickId
      })
    : finalReferralCode
      ? queryString.stringify({
          referral: finalReferralCode
        })
      : undefined;

  const hrefMaybeWithParams = queryParams ? `${href}?${queryParams}` : href;

  return (
    <Button asChild id={id} variant="theme" {...props}>
      <Link href={hrefMaybeWithParams}>{label}</Link>
    </Button>
  );
}
